import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Layout from "../Components/Layout/Body/index";
import { Home } from "../Pages/Home";
import ProtectedRoute from "../RouterPath/protectedRoute"; // Import ProtectedRoute
import { getUserDataFromToken } from "../Utils/urlAuthHandler";

// Import dashboard components for each role
import CPODashboard from "../Pages/Dashboards/Products/CPODashboard";
import ProductManagerDashboard from "../Pages/Dashboards/Products/ProductManagerDashboard";
import AssociateProductManagerDashboard from "../Pages/Dashboards/Products/AssociateProductManagerDashboard";
import JuniorProductManagerDashboard from "../Pages/Dashboards/Products/JuniorProductManagerDashboard";
import ProductInternDashboard from "../Pages/Dashboards/Products/ProductInternDashboard";

import CMODashboard from "../Pages/Dashboards/MarketingAndGrowth/CMODashboard";
import GrowthMarketingDashboard from "../Pages/Dashboards/MarketingAndGrowth/GrowthMarketingDashboard";
import ContentStrategistDashboard from "../Pages/Dashboards/MarketingAndGrowth/ContentStrategistDashboard";
import SocialMediaDashboard from "../Pages/Dashboards/MarketingAndGrowth/SocialMediaDashboard";

import VPSalesDashboard from "../Pages/Dashboards/SalesAndBusinessDev/VPSalesDashboard";
import SalesManagerDashboard from "../Pages/Dashboards/SalesAndBusinessDev/SalesManagerDashboard";
import BusinessDevelopmentDashboard from "../Pages/Dashboards/SalesAndBusinessDev/BusinessDevelopmentDashboard";
import ExecutiveTraineeDashboard from "../Pages/Dashboards/SalesAndBusinessDev/ExecutiveTraineeDashboard";

import ContentScheduler from "../Pages/MarketingAndGrowth/ContentScheduler";

import UmbrellaView from "../Pages/FounderAndChairman/UmbrellaView/index";
import CompanyOverview from "../Pages/FounderAndChairman/CompanyOverview/index";

import MyTaskDashboard from "../Pages/Tasks/Dashboard/index";
import MyTask from "../Pages/Tasks/MyTask/index";
import AllTask from "../Pages/AllTask/index";


import CreateTask from "../Pages/Tasks/CreateTask/index";

import People from "../Pages/HumanResources/People/index";
import Leave from "../Pages/HumanResources/Leave/index";
import LeaveApplyForm from "../Pages/HumanResources/Leave/LeaveApplyForm/index";
import CreatePeople from "../Pages/HumanResources/CreatePeople/index";
import Planner from "../Pages/HumanResources/Planner/index";

// Import Master Data components
import Roles from "../Pages/MasterData/Roles/index";
import Departments from "../Pages/MasterData/Departments/index";
import Grades from "../Pages/MasterData/Grades/index";
import LeaveTypes from "../Pages/MasterData/LeaveTypes/index";
import Countries from "../Pages/MasterData/Countries/index";
import Levels from "../Pages/MasterData/Levels/index"; // This is actually Levels component
import Designations from "../Pages/MasterData/Designations/index";


// Root Route Component - checks authentication and redirects
const RootRoute = () => {
  const { isAuthenticated } = getUserDataFromToken();

  if (isAuthenticated) {
    return <Navigate to="/task-dashboard" replace />;
  } else {
    // Redirect to external login
    window.location.href = "https://www.people.oruclick.com/";
    return null;
  }
};

const RoutePath = ({ isDarkTheme }) => {
  useEffect(() => {
    const handleInvalidToken = (e) => {
      if (e.key === "apptoken" && e.oldValue && !e.newValue) {
      }
    };

    window.addEventListener("storage", handleInvalidToken);
    return function cleanup() {
      window.removeEventListener("storage", handleInvalidToken);
    };
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route element={<Layout isDarkTheme={isDarkTheme} />}>
          {/* Root Route - checks authentication */}
          <Route path="/" element={<RootRoute />} />

          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/home" element={<Home />} />

            {/* Role-Based Routes */}
            <Route path="/umbrella-view" element={<UmbrellaView />} />
            <Route path="/company-overview" element={<CompanyOverview />} />
            {/* Yet to fix */}
            <Route path="/task-dashboard" element={<MyTaskDashboard />} />
            {/* working fine  */}
            <Route path="/my-tasks" element={<MyTask />} />
            <Route path="/all-tasks" element={<AllTask />} />
            <Route path="/my-leave" element={<Leave />} />
            <Route path="/planner" element={<Planner />} />

            <Route path="/add-task" element={<CreateTask />} />

            <Route path="/people" element={<People />} />
            <Route path="/create-people" element={<CreatePeople />} />

            <Route path="/cpo-dashboard" element={<CPODashboard />} />
            <Route
              path="/product-manager-dashboard"
              element={<ProductManagerDashboard />}
            />
            <Route
              path="/associate-product-manager-dashboard"
              element={<AssociateProductManagerDashboard />}
            />
            <Route
              path="/junior-product-manager-dashboard"
              element={<JuniorProductManagerDashboard />}
            />
            <Route
              path="/product-intern-dashboard"
              element={<ProductInternDashboard />}
            />
            <Route path="/cmo-dashboard" element={<CMODashboard />} />
            <Route
              path="/growth-marketing-dashboard"
              element={<GrowthMarketingDashboard />}
            />
            <Route
              path="/content-strategist-dashboard"
              element={<ContentStrategistDashboard />}
            />
            <Route
              path="/social-media-dashboard"
              element={<SocialMediaDashboard />}
            />
            <Route path="/vp-sales-dashboard" element={<VPSalesDashboard />} />
            <Route
              path="/sales-manager-dashboard"
              element={<SalesManagerDashboard />}
            />
            <Route
              path="/business-development-dashboard"
              element={<BusinessDevelopmentDashboard />}
            />
            <Route
              path="/executive-trainee-dashboard"
              element={<ExecutiveTraineeDashboard />}
            />

            <Route path="/content-scheduler" element={<ContentScheduler />} />
            <Route path="/apply-leave" element={<LeaveApplyForm />} />

            {/* Master Data Routes */}
            <Route path="/master-data/roles" element={<Roles />} />
            <Route path="/master-data/departments" element={<Departments />} />
            <Route path="/master-data/grades" element={<Grades />} />
            <Route path="/master-data/leave-types" element={<LeaveTypes />} />
            <Route path="/master-data/countries" element={<Countries />} />
            <Route path="/master-data/levels" element={<Levels />} />
            <Route path="/master-data/designations" element={<Designations />} />
            

            {/* Add more role-based routes as needed */}
          </Route>
        </Route>
      </Routes>
    </div>
  );
};
export default RoutePath;
